// 预取 boot 脚本与主工程共享的 LOCALES「单一事实源」。
//
// LOCALES 同时被两处使用，且「漂移」后果隐蔽严重（语言列表不一致 → 剥前缀出错 → 路由判断
// 错）。它在 constant/storage.ts 里没有对应源，故单列此中立文件作唯一真相：
//   - 主工程侧：locales/index.ts 的 LOCALES 从这里取。
//   - boot 侧：packages/sw-prefetch/src/prefetch-boot.ts 经 esbuild 打包时内联这些值。
// 两边永不漂移，无需人工同步。
//
// 注：NSFW key / USER key 等「storage.ts 已有的」常量不放这里——它们直接复用
// storageKey.HOMENSFWSTATE / storageKey.USER（见 packages/sw-prefetch/src/prefetch/constants.ts、
// constant/prefetch-user.ts），由 esbuild 内联+tree-shake，无需另立常量。
//
// 本文件必须零 import（纯字面量）——esbuild 把它打进 boot 时不会牵连其他模块。

export const PREFETCH_LOCALES = [
  'cs',
  'da',
  'de',
  'en',
  'es',
  'fi',
  'fil',
  'fr',
  'hu',
  'id',
  'it',
  'ja',
  'ko',
  'ms',
  'nl',
  'no',
  'pl',
  'pt',
  'pt-br',
  'ro',
  'ru',
  'sv',
  'th',
  'tr',
  'vi',
  'zh-tw',
] as const
